import Form, {SimpleItem, GroupItem, Label} from 'devextreme-react/form'
import { Button } from 'devextreme-react/button'
import { useAuth } from '../../contexts/auth'
import { useReqPopup } from '../../contexts/req-popup'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleUser, faFileLines, faCircleInfo, faFolder} from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from 'react';
import { verifyAccess } from '../../utils/admin.utils';
import AccessDenied from '../../components/access-denied/access-denied';
import { getDoc, getDocs, getFinInfoSum, getContractPage, getManager } from '../../api/dogovor';
import {
    emptyContractPage,
    mapDogovorToContractPage,
    mergeContractPageWithDogovor
} from './contract-page.mapper';
import DataGrid, {Column, Pager, Paging, Scrolling} from 'devextreme-react/data-grid'
import notify from 'devextreme/ui/notify';
import LoadPanel from 'devextreme-react/load-panel';
import { Buffer } from 'buffer';
import './dogovor.scss'
import ZagolovokFromMenu from "../../components/zagolovok/zagolovok";

const finNumber = (value) => {
    if (typeof value === 'number' && !Number.isNaN(value)) return value
    if (typeof value === 'string' && value.trim() !== '' && !Number.isNaN(+value)) return +value
    return 0
}

const Dogovor = () => {

    const auth = useAuth()
    const dogovor = auth.selectedDog
    const { openReqPopup } = useReqPopup()

    const [pageData, setPageData] = useState(emptyContractPage())
    const textAreaOptions = (value) => ({ value: value ?? '', autoResizeEnabled: true, minHeight: 35 })
    const formatDateDisplay = (value) => {
        if (!value) return ''
        const d = new Date(value)
        if (!Number.isNaN(d.getTime())) return d.toLocaleDateString('ru-RU')
        return String(value)
    }
    const dateFieldOptions = (value) => textAreaOptions(formatDateDisplay(value))

    const { contract, bankPayer, bankPayment, counterparty, filial, responsiblePersons } = pageData

    const ndogEditorOptions = textAreaOptions(contract.ndog)
    const datNumdogEditorOptions = dateFieldOptions(contract.datNumdog)
    const datDogEditorOptions = dateFieldOptions(contract.datDog)
    const datFinDogEditorOptions = dateFieldOptions(contract.datFin)
    const statusDogEditorOptions = textAreaOptions(contract.statusDog)
    const addressDogEditorOptions = textAreaOptions(counterparty.adrDP)
    const emailDogEditorOptions = textAreaOptions(counterparty.emailDog)

    const bplatNameEditorOptions = textAreaOptions(bankPayer.bplatName)
    const bplatRsEditorOptions = textAreaOptions(bankPayer.bplatRs)
    const bplatBicEditorOptions = textAreaOptions(bankPayer.bplatBic)
    const bplatKsEditorOptions = textAreaOptions(bankPayer.bplatKs)
    const filialNameEditorOptions = textAreaOptions(filial.filialName)
    const filialAdrEditorOptions = textAreaOptions(filial.filialAdr)

    const bpolNameEditorOptions = textAreaOptions(bankPayment.bpolName)
    const bpolRsEditorOptions = textAreaOptions(bankPayment.bpolRs)
    const bpolBicEditorOptions = textAreaOptions(bankPayment.bpolBic)
    const bpolKsEditorOptions = textAreaOptions(bankPayment.bpolKs)

    const nameEditorOptions = textAreaOptions(counterparty.name)
    const innEditorOptions = textAreaOptions(counterparty.inn)
    const kppEditorOptions = textAreaOptions(counterparty.kpp)
    const ogrnEditorOptions = textAreaOptions(counterparty.ogrn)
    const okpoEditorOptions = textAreaOptions(counterparty.okpo)
    const okvedUrEditorOptions = textAreaOptions(counterparty.okved)
    const fioDirEditorOptions = textAreaOptions(counterparty.fioDir)
    const srokDogEditorOptions = textAreaOptions(contract.srokDog)
    const telDogEditorOptions = textAreaOptions(counterparty.tel)
    const edoEditorOptions = textAreaOptions(counterparty.edo)
    const adrUrReadonlyEditorOptions = textAreaOptions(counterparty.adrUr)
    const adrDPReadonlyEditorOptions = textAreaOptions(counterparty.adrDP)
    const adrUrEditorOptions = {value: counterparty.adrUr ?? '', autoResizeEnabled:true, minHeight:35, readOnly: false,
        buttons: [{
            name: 'edit',
            location: 'after',
            options: {
                readOnly: false,
                stylingMode: 'text',
                icon: 'edit',
                onClick: () => {
                    openReqPopup(true, 2, `Прошу изменить адрес юридический для договора в связи с: впишите сюда причину смены адреса.`)
                },
            },
        }]}
    const adrDEditorOptions = {value: counterparty.adrD ?? '', autoResizeEnabled:true, minHeight:35, readOnly: false,
        buttons: [{
            name: 'edit',
            location: 'after',
            options: {
                stylingMode: 'text',
                icon: 'edit',
                onClick: () => {
                    openReqPopup(true, 2, "Прошу изменить адрес фактический для договора в связи с: впишите сюда причину смены адреса.")
                },
            },
        }]}
    const adrDPEditorOptions = {value: counterparty.adrDP ?? '', autoResizeEnabled:true, minHeight:35, readOnly: false,
        buttons: [{
            name: 'edit',
            location: 'after',
            options: {
                stylingMode: 'text',
                icon: 'edit',
                onClick: () => {
                    openReqPopup(true, 2, "Прошу изменить адрес для переписки для договора в связи с: впишите сюда причину смены адреса.")
                },
            },
        }]}

    const [visiblePage, setVisiblePage] = useState(true)
    const [manager, setManager] = useState(null)
    const [loadingManager, setLoadingManager] = useState(false)
    const [docs, setDocs] = useState([])
    const [loadingDocs, setLoadingDocs] = useState(false)
    const [downloadingDoc, setDownloadingDoc] = useState(false)
    const [finInfoSum, setFinInfoSum] = useState(null)
    const pageSizes = [10, 25, 50]
    const isRenergy = process.env.REACT_APP_NAME_ENV === 'renergy'
    const isNeskLayout = process.env.REACT_APP_NAME_ENV === 'infoenergo'
    const isGpLayout = isRenergy
    const isTatenergosbyt = process.env.REACT_APP_NAME_ENV === 'tatenergosbyt'
    // Финансовый блок на /dogovor только для НЭСК (К оплате без детализации).
    // ГП/ФИКС: детализация раскрыта на /dogovor-actions, на остальных страницах — попап в SelectDogovor.
    const showFinBlock = isNeskLayout

    const responsibleNotification = responsiblePersons.notification
    const responsibleExecution = responsiblePersons.execution
    const responsibleMeters = responsiblePersons.meters
    const responsiblePayments = responsiblePersons.payments
    const hasResponsiblePersonData = (person = {}) =>
        [person.fio, person.tel, person.fax, person.email]
            .some((value) => String(value || '').trim() !== '')
    const hasResponsibleNotification = hasResponsiblePersonData(responsibleNotification)
    const hasResponsibleExecution = hasResponsiblePersonData(responsibleExecution)
    const hasResponsibleMeters = hasResponsiblePersonData(responsibleMeters)
    const hasResponsiblePayments = hasResponsiblePersonData(responsiblePayments)

    const formatMoney = (value) => (+(value || 0)).toLocaleString('ru', { style: "currency", currency: "RUB" })
    const formatToPay = (value) => formatMoney(Math.max(0, +(value || 0)))
    const formatDate = (value) => {
        if (!value) return null
        const d = new Date(value)
        if (!Number.isNaN(d.getTime())) {
            return d.toLocaleDateString('ru-RU')
        }
        return null
    }

    const payDateLabel = formatDate(finInfoSum?.date_pay)

    useEffect(() => {
        const controller = new AbortController();
        const {signal} = controller;

        const pageRoles = [2,3]
        if (!verifyAccess(pageRoles, dogovor)){
            setVisiblePage(false)
            return
        }
        (async function(){
            setVisiblePage(true)

            const fallbackPage = mapDogovorToContractPage(dogovor)
            setPageData(fallbackPage)

            const resContractPage = await getContractPage(dogovor.kodDog)
            if (resContractPage.isOk) {
                const { page } = mergeContractPageWithDogovor(resContractPage.data, dogovor)
                setPageData(page)
            }

            if (showFinBlock) {
                const resFinInfo = await getFinInfoSum(dogovor.kodDog)
                const finData = resFinInfo.isOk ? (resFinInfo.data || {}) : {}
                if (!resFinInfo.isOk) notify(resFinInfo.message, 'error', 5000)

                setFinInfoSum({
                    sum_dolg: finNumber(finData.sum_dolg),
                    sum_energy: finNumber(finData.sum_energy),
                    sum_overpay: 0,
                    sum_tax: 0,
                    sum_peni: 0,
                    sum_imminent: 0,
                    date_pay: finData.date_pay ?? null
                })
            } else {
                setFinInfoSum(null)
            }

            // Казань (TES): персональный менеджер — как до UI-переделок страницы договора
            if (isTatenergosbyt) {
                setLoadingManager(true)
                const resManager = await getManager(dogovor.kodDog)
                if (resManager.isOk && resManager.data?.manager) setManager(resManager.data.manager)
                else setManager(null)
                setLoadingManager(false)
            } else {
                setManager(null)
            }

            //достаем документы
            setLoadingDocs(true)
            try {
                const resDocs = await getDocs(dogovor.kodDog)
                signal?.throwIfAborted();
                if (resDocs.isOk) setDocs(resDocs.data)
                else notify(resDocs.message, 'error', 5000)
            }
            catch(exx){}
            setLoadingDocs(false)
        })()
        return () => controller.abort(new Error('Starting next render'));
    }, [dogovor, showFinBlock, isTatenergosbyt])

    useEffect(() => {
        setTimeout(() => {
            // костыль по обходу readonly поля с кнопкой
            let elems = document.querySelectorAll(".textarea-readonly textarea")
            for (let elem of elems) {
                elem.setAttribute('readonly', '');
            }
        },100)
    },[])

    function loadDocRender(e) {
        const id = e.data.kod_dopdoc
        return <a href='#/dogovor' onClick={()=>{downloadDoc(id)}}>{e.value}</a>
    }

    async function downloadDoc(kodDoc) {
        setDownloadingDoc(true)

        const res = await getDoc(kodDoc)
        if (res.isOk) {
            try {
                const data = res.data.file
                const filename  = res.data.nameFile
                let fileDownload = require('js-file-download')
                fileDownload(Buffer.from(data), filename)
            } catch (e) {
                notify("Файл отсутствует",'error',5000)
            }

        } else {
            notify(res.message, 'error', 5000)
        }

        setDownloadingDoc(false)
    }

    const renderExecutionResponsibilities = () => (
        <ul className="responsible-execution-list">
            <li>обеспечение сохранности прибора учета и систем учета</li>
            <li>предоставление доступа к месту установки прибора учета</li>
            <li>снятие и предоставление показаний прибора учета, в т.ч. акта снятия показаний прибора учета</li>
        </ul>
    )

    const renderDocuments = () => (
        <>
            <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faFolder} />
            <h3><strong>Документы по договору</strong></h3>
            <LoadPanel visible={downloadingDoc} />
            {
                !loadingDocs && docs.length === 0 ?
                   <div className='mb-5'>Нет документов по договору.</div> :
                    loadingDocs ?
                        'Загрузка документов по договору...' :
                        <DataGrid
                            id='dogovor-docs'
                            dataSource={docs}
                            showBorders={true}
                            allowColumnReordering={true}
                            wordWrapEnabled={true}
                            columnWidth={'auto'}
                            width={'100%'}
                        >
                            <Scrolling columnRenderingMode="virtual" />
                            <Column dataField="name_type" dataType="string" caption="Тип документа"></Column>
                            <Column dataField="name_file" dataType="string" caption="Наименование файла" cellRender={loadDocRender}></Column>
                            <Column dataField="num_doc" dataType="string" caption="Номер документа"></Column>
                            <Column dataField="dat_doc" dataType="date" caption="Дата документа"></Column>
                            <Column dataField="obj_name" dataType="string" caption="Объект электроснабжения"></Column>
                            <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
                            <Paging defaultPageSize={10} />
                        </DataGrid>
            }
        </>
    )

    /*const renderAddressButtons = () => (
        <div className="row mt20">
            <div className="col-12 col-sm-6 mb-2">
                <Button
                    type={'default'}
                    className={'block big-button'}
                    text="Изменение юридического адреса"
                    onClick={() => openReqPopup(true, 2, `Прошу изменить адрес юридический для договора в связи с: впишите сюда причину смены адреса.`)}
                />
            </div>
            <div className="col-12 col-sm-6 mb-2">
                <Button
                    type={'default'}
                    className={'block big-button'}
                    text="Изменение адреса для переписки"
                    onClick={() => openReqPopup(true, 2, "Прошу изменить адрес для переписки для договора в связи с: впишите сюда причину смены адреса.")}
                />
            </div>
        </div>
    )*/

    return (
        <>{visiblePage ?
        <div className={'content-block dx-card responsive-paddings big-input'}>
            {showFinBlock && (
                <div className="row align-items-start mb-3">
                    <div className="col-lg-8 col-md-12">
                        <h4>
                            К оплате {payDateLabel ? `на ${payDateLabel}` : ''}: {formatToPay(finInfoSum?.sum_dolg)}
                        </h4>
                    </div>
                    <div className="col-lg-4 col-md-12 text-lg-right mt20md">
                        <Button
                            type={'default'}
                            className={'big-button'}
                            text="Оплатить"
                            icon="money"
                            onClick={() => window.location.hash = '#/debt'}
                        />
                    </div>
                </div>
            )}
            {isNeskLayout ? (
                <div className="row mt20">
                    <div className="col-md-6">
                        <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faFileLines} />
                        <h3><strong><ZagolovokFromMenu/></strong></h3>
                        <Form labelMode={'floating'} id="form-dogovor" readOnly={true}>
                            <GroupItem caption="">
                                <SimpleItem dataField="Номер_договора" editorType="dxTextArea" editorOptions={ndogEditorOptions}>
                                    <Label text="Номер договора"/>
                                </SimpleItem>
                                <GroupItem colCount={2}>
                                    <SimpleItem dataField="Начало_действия" editorType="dxTextArea" editorOptions={datDogEditorOptions}>
                                        <Label text="Дата начала действия договора"/>
                                    </SimpleItem>
                                    <SimpleItem dataField="Срок_действия" editorType="dxTextArea" editorOptions={srokDogEditorOptions}>
                                        <Label text="Срок действия договора"/>
                                    </SimpleItem>
                                </GroupItem>
                                <GroupItem colCount={1} caption="Банковские реквизиты">
                                    <GroupItem colCount={2}>
                                        <SimpleItem dataField="Банк" editorType="dxTextArea" editorOptions={bplatNameEditorOptions} />
                                        <SimpleItem dataField="Кор._счет" editorType="dxTextArea" editorOptions={bplatKsEditorOptions}>
                                            <Label text="Кор.счет"/>
                                        </SimpleItem>
                                    </GroupItem>
                                    <GroupItem colCount={2}>
                                        <SimpleItem dataField="Расчетный_счет" editorType="dxTextArea" editorOptions={bplatRsEditorOptions} />
                                        <SimpleItem dataField="БИК" editorType="dxTextArea" editorOptions={bplatBicEditorOptions} />
                                    </GroupItem>
                                </GroupItem>
                                <GroupItem colCount={1} caption="Реквизиты для оплаты">
                                    <GroupItem colCount={2}>
                                        <SimpleItem dataField="Банк" editorType="dxTextArea" editorOptions={bpolNameEditorOptions} />
                                        <SimpleItem dataField="Кор._счет" editorType="dxTextArea" editorOptions={bpolKsEditorOptions}>
                                            <Label text="Кор.счет"/>
                                        </SimpleItem>
                                    </GroupItem>
                                    <GroupItem colCount={2}>
                                        <SimpleItem dataField="Расчетный_счет" editorType="dxTextArea" editorOptions={bpolRsEditorOptions} />
                                        <SimpleItem dataField="БИК" editorType="dxTextArea" editorOptions={bpolBicEditorOptions} />
                                    </GroupItem>
                                </GroupItem>
                            </GroupItem>
                        </Form>

                        <FontAwesomeIcon className="icon-header-h3 main-color main-color-light mt20" icon={faCircleUser} />
                        <h4><strong>Сведения об ответственных лицах</strong></h4>
                        <Form labelMode={'floating'} id="form-dogovor3" readOnly={true}>
                            {hasResponsibleNotification && (
                            <GroupItem caption="Контакты для направления уведомлений о введении ограничения режима потребления электрической энергии:">
                                <GroupItem colCount={2}>
                                    <SimpleItem dataField="Мобильный_телефон" editorType="dxTextArea" editorOptions={textAreaOptions(responsibleNotification.tel)}/>
                                    <SimpleItem dataField='Email' editorType="dxTextArea" editorOptions={textAreaOptions(responsibleNotification.email)}/>
                                </GroupItem>
                            </GroupItem>
                            )}
                            {hasResponsibleExecution && (
                            <GroupItem caption="Лицо, ответственное за исполнение договора энергоснабжения:">
                                <SimpleItem cssClass="responsible-execution-item" render={renderExecutionResponsibilities}/>
                                <SimpleItem dataField="ФИО" editorType="dxTextArea" editorOptions={textAreaOptions(responsibleExecution.fio)}/>
                                <GroupItem colCount={2}>
                                    <SimpleItem dataField="Телефон" editorType="dxTextArea" editorOptions={textAreaOptions(responsibleExecution.tel)}/>
                                    <SimpleItem dataField='Email' editorType="dxTextArea" editorOptions={textAreaOptions(responsibleExecution.email)}/>
                                </GroupItem>
                            </GroupItem>
                            )}
                            {hasResponsibleMeters && (
                            <GroupItem caption="Лицо, ответственное за приборы и показания:">
                                <SimpleItem dataField="ФИО" editorType="dxTextArea" editorOptions={textAreaOptions(responsibleMeters.fio)}/>
                                <GroupItem colCount={2}>
                                    <SimpleItem dataField="Телефон" editorType="dxTextArea" editorOptions={textAreaOptions(responsibleMeters.tel)}/>
                                    <SimpleItem dataField='Email' editorType="dxTextArea" editorOptions={textAreaOptions(responsibleMeters.email)}/>
                                </GroupItem>
                            </GroupItem>
                            )}
                            {hasResponsiblePayments && (
                            <GroupItem caption="Лицо, ответственное за взаиморасчеты и получение счетов на оплату:">
                                <SimpleItem dataField="ФИО" editorType="dxTextArea" editorOptions={textAreaOptions(responsiblePayments.fio)}/>
                                <GroupItem colCount={2}>
                                    <SimpleItem dataField="Телефон" editorType="dxTextArea" editorOptions={textAreaOptions(responsiblePayments.tel)}/>
                                    <SimpleItem dataField='Email' editorType="dxTextArea" editorOptions={textAreaOptions(responsiblePayments.email)}/>
                                </GroupItem>
                            </GroupItem>
                            )}
                        </Form>
                    </div>
                    <div className="col-md-6 mt20md">
                        <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faCircleInfo} />
                        <h3><strong>Информация о контрагенте</strong></h3>
                        <Form labelMode={'floating'} id="form-dogovor2" readOnly={true}>
                            <GroupItem caption="">
                                <SimpleItem dataField="Наименование_контрагента" editorType="dxTextArea" editorOptions={nameEditorOptions}>
                                    <Label text="Полное наименование контрагента"/>
                                </SimpleItem>
                                <SimpleItem dataField="Адрес_юридический" editorType="dxTextArea" editorOptions={adrUrReadonlyEditorOptions} />
                                <SimpleItem dataField="Адрес_для_переписки" editorType="dxTextArea" editorOptions={adrDPReadonlyEditorOptions} />
                                <GroupItem colCount={2}>
                                    <SimpleItem dataField="ОКВЭД" editorType="dxTextArea" editorOptions={okvedUrEditorOptions} />
                                    <SimpleItem dataField='ИНН' editorType="dxTextArea" editorOptions={innEditorOptions} />
                                </GroupItem>
                                <GroupItem colCount={2}>
                                    <SimpleItem dataField="КПП" editorType="dxTextArea" editorOptions={kppEditorOptions} />
                                    <SimpleItem dataField="Email" editorType="dxTextArea" editorOptions={emailDogEditorOptions} />
                                </GroupItem>
                                <GroupItem colCount={2}>
                                    <SimpleItem dataField="Телефон" editorType="dxTextArea" editorOptions={telDogEditorOptions} />
                                    <SimpleItem dataField="ФИО_руководителя" editorType="dxTextArea" editorOptions={fioDirEditorOptions}>
                                        <Label text="ФИО руководителя"/>
                                    </SimpleItem>
                                </GroupItem>
                                <SimpleItem dataField="Наличие_ЭДО" editorType="dxTextArea" editorOptions={edoEditorOptions}>
                                    <Label text="Наличие ЭДО"/>
                                </SimpleItem>
                            </GroupItem>
                        </Form>
                        {/*{renderAddressButtons()}*/}
                        <div className="mt20">
                            {renderDocuments()}
                        </div>
                    </div>
                </div>
            ) : isGpLayout ? (
            <>
            <div className="row mt20">
                <div className="col-md-6">
                    <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faFileLines} />
                    <h3><strong><ZagolovokFromMenu/></strong></h3>
                    <Form labelMode={'floating'} id="form-dogovor-gp" readOnly={true}>
                        <GroupItem caption="">
                            <SimpleItem dataField="Номер_договора" editorType="dxTextArea" editorOptions={ndogEditorOptions}>
                                <Label text="Номер договора"/>
                            </SimpleItem>
                            <GroupItem colCount={2}>
                                <SimpleItem dataField="Начало_действия" editorType="dxTextArea" editorOptions={datDogEditorOptions}>
                                    <Label text="Дата начала действия договора"/>
                                </SimpleItem>
                                <SimpleItem dataField="Срок_действия" editorType="dxTextArea" editorOptions={srokDogEditorOptions}>
                                    <Label text="Срок действия договора"/>
                                </SimpleItem>
                            </GroupItem>
                            <GroupItem colCount={1} caption="Банковские реквизиты">
                                <GroupItem colCount={2}>
                                    <SimpleItem dataField="Банк" editorType="dxTextArea" editorOptions={bplatNameEditorOptions} />
                                    <SimpleItem dataField="Кор._счет" editorType="dxTextArea" editorOptions={bplatKsEditorOptions}>
                                        <Label text="Кор.счет"/>
                                    </SimpleItem>
                                </GroupItem>
                                <GroupItem colCount={2}>
                                    <SimpleItem dataField="Расчетный_счет" editorType="dxTextArea" editorOptions={bplatRsEditorOptions} />
                                    <SimpleItem dataField="БИК" editorType="dxTextArea" editorOptions={bplatBicEditorOptions} />
                                </GroupItem>
                            </GroupItem>
                            <GroupItem colCount={1} caption="Реквизиты для оплаты">
                                <GroupItem colCount={2}>
                                    <SimpleItem dataField="Банк" editorType="dxTextArea" editorOptions={bpolNameEditorOptions} />
                                    <SimpleItem dataField="Кор._счет" editorType="dxTextArea" editorOptions={bpolKsEditorOptions}>
                                        <Label text="Кор.счет"/>
                                    </SimpleItem>
                                </GroupItem>
                                <GroupItem colCount={2}>
                                    <SimpleItem dataField="Расчетный_счет" editorType="dxTextArea" editorOptions={bpolRsEditorOptions} />
                                    <SimpleItem dataField="БИК" editorType="dxTextArea" editorOptions={bpolBicEditorOptions} />
                                </GroupItem>
                            </GroupItem>
                        </GroupItem>
                    </Form>
                </div>
                <div className="col-md-6 mt20md">
                    <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faCircleInfo} />
                    <h3><strong>Информация о контрагенте</strong></h3>
                    <Form labelMode={'floating'} id="form-dogovor2-gp" readOnly={true}>
                        <GroupItem caption="">
                            <SimpleItem dataField="Наименование_контрагента" editorType="dxTextArea" editorOptions={nameEditorOptions}>
                                <Label text="Полное наименование контрагента"/>
                            </SimpleItem>
                            <SimpleItem cssClass={'textarea-readonly'} dataField="Адрес_юридический" editorType="dxTextArea" editorOptions={adrUrEditorOptions} />
                            <SimpleItem cssClass={'textarea-readonly'} dataField="Адрес_фактический" editorType="dxTextArea" editorOptions={adrDEditorOptions} />
                            <SimpleItem cssClass={'textarea-readonly'} dataField="Адрес_для_переписки" editorType="dxTextArea" editorOptions={adrDPEditorOptions} />
                            <GroupItem colCount={2}>
                                <SimpleItem dataField="ОКВЭД" editorType="dxTextArea" editorOptions={okvedUrEditorOptions} />
                                <SimpleItem dataField='ИНН' editorType="dxTextArea" editorOptions={innEditorOptions} />
                            </GroupItem>
                            <GroupItem colCount={2}>
                                <SimpleItem dataField="КПП" editorType="dxTextArea" editorOptions={kppEditorOptions} />
                                <SimpleItem dataField="Email" editorType="dxTextArea" editorOptions={emailDogEditorOptions} />
                            </GroupItem>
                            <GroupItem colCount={2}>
                                <SimpleItem dataField="Телефон" editorType="dxTextArea" editorOptions={telDogEditorOptions} />
                                <SimpleItem dataField="ФИО_руководителя" editorType="dxTextArea" editorOptions={fioDirEditorOptions}>
                                    <Label text="ФИО руководителя"/>
                                </SimpleItem>
                            </GroupItem>
                            <SimpleItem dataField="Наличие_ЭДО" editorType="dxTextArea" editorOptions={edoEditorOptions}>
                                <Label text="Наличие ЭДО"/>
                            </SimpleItem>
                        </GroupItem>
                    </Form>
                    {/*{renderAddressButtons()}*/}
                </div>
            </div>
            <div className="row mt20">
                <div className="col-md-6">
                    <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faCircleUser} />
                    <h3><strong>Сведения об ответственных лицах заявителя</strong></h3>
                    <Form labelMode={'floating'} id="form-dogovor3-gp" readOnly={true}>
                        {hasResponsibleNotification && (
                        <GroupItem caption="Контакты для направления уведомлений о введении ограничения режима потребления электрической энергии:">
                            <GroupItem colCount={2}>
                                <SimpleItem dataField="Мобильный_телефон" editorType="dxTextArea" editorOptions={textAreaOptions(responsibleNotification.tel)}/>
                                <SimpleItem dataField='Факс' editorType="dxTextArea" editorOptions={textAreaOptions(responsibleNotification.fax)}/>
                            </GroupItem>
                            <SimpleItem dataField='Email' editorType="dxTextArea" editorOptions={textAreaOptions(responsibleNotification.email)}/>
                        </GroupItem>
                        )}
                        {hasResponsibleExecution && (
                        <GroupItem caption="Лицо, ответственное за исполнение договора энергоснабжения:">
                            <SimpleItem cssClass="responsible-execution-item" render={renderExecutionResponsibilities}/>
                            <SimpleItem dataField="ФИО" editorType="dxTextArea" editorOptions={textAreaOptions(responsibleExecution.fio)}/>
                            <GroupItem colCount={2}>
                                <SimpleItem dataField="Телефон" editorType="dxTextArea" editorOptions={textAreaOptions(responsibleExecution.tel)}/>
                                <SimpleItem dataField='Email' editorType="dxTextArea" editorOptions={textAreaOptions(responsibleExecution.email)}/>
                            </GroupItem>
                        </GroupItem>
                        )}
                        {hasResponsibleMeters && (
                        <GroupItem caption="Лицо, ответственное за приборы и показания:">
                            <SimpleItem dataField="ФИО" editorType="dxTextArea" editorOptions={textAreaOptions(responsibleMeters.fio)}/>
                            <GroupItem colCount={2}>
                                <SimpleItem dataField="Телефон" editorType="dxTextArea" editorOptions={textAreaOptions(responsibleMeters.tel)}/>
                                <SimpleItem dataField='Email' editorType="dxTextArea" editorOptions={textAreaOptions(responsibleMeters.email)}/>
                            </GroupItem>
                        </GroupItem>
                        )}
                        {hasResponsiblePayments && (
                        <GroupItem caption="Лицо, ответственное за взаиморасчеты и получение счетов на оплату:">
                            <SimpleItem dataField="ФИО" editorType="dxTextArea" editorOptions={textAreaOptions(responsiblePayments.fio)}/>
                            <GroupItem colCount={2}>
                                <SimpleItem dataField="Телефон" editorType="dxTextArea" editorOptions={textAreaOptions(responsiblePayments.tel)}/>
                                <SimpleItem dataField='Email' editorType="dxTextArea" editorOptions={textAreaOptions(responsiblePayments.email)}/>
                            </GroupItem>
                        </GroupItem>
                        )}
                    </Form>
                </div>
                <div className="col-md-6 mt20md">
                    {renderDocuments()}
                </div>
            </div>
            </>
            ) : (
            <>
            <div className="row mt20">
                <div className="col-md-6">
                    <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faFileLines} />
                    <h3><strong><ZagolovokFromMenu/></strong></h3>
                    <Form labelMode={'floating'}
                          id="form-dogovor" readOnly={true}
                    >
                        <GroupItem caption="">
                            <SimpleItem dataField="Номер_договора" editorType="dxTextArea" editorOptions={ndogEditorOptions} />
                            <GroupItem colCount={2}>
                                <SimpleItem dataField="Начало_действия" editorType="dxTextArea" editorOptions={datDogEditorOptions} />
                                <SimpleItem dataField="Дата_заключения" editorType="dxTextArea" editorOptions={datNumdogEditorOptions} />
                            </GroupItem>
                            <GroupItem colCount={2} cssClass='display-tatenergosbyt'>
                                <SimpleItem dataField="Дата_прекращения" editorType="dxTextArea" editorOptions={datFinDogEditorOptions} />
                                <SimpleItem dataField="Статус_договора" editorType="dxTextBox" editorOptions={statusDogEditorOptions} />
                            </GroupItem>

                            <SimpleItem dataField="Адрес для переписки" editorType="dxTextArea" editorOptions={addressDogEditorOptions} cssClass='display-tatenergosbyt'/>
                            <SimpleItem dataField="Email" editorType="dxTextArea" editorOptions={emailDogEditorOptions} cssClass='display-tatenergosbyt'/>

                            {/*<GroupItem colCount={1} caption="Банковские реквизиты" cssClass='display-tatenergosbyt'>*/}
                            <SimpleItem dataField="Банк" editorType="dxTextArea" editorOptions={bplatNameEditorOptions} />
                            <SimpleItem dataField="Расчетный_счет" editorType="dxTextArea" editorOptions={bplatRsEditorOptions} />
                            <GroupItem colCount={2}>
                                <SimpleItem dataField="БИК" editorType="dxTextArea" editorOptions={bplatBicEditorOptions} />
                                <SimpleItem dataField="Кор._счет" editorType="dxTextArea" editorOptions={bplatKsEditorOptions}>
                                    <Label text={"Кор. счёт"}/>
                                </SimpleItem>
                            </GroupItem>

                            <GroupItem colCount={1} caption="Реквизиты для оплаты" cssClass='display-tatenergosbyt'>
                                <SimpleItem dataField="Банк" editorType="dxTextArea" editorOptions={bpolNameEditorOptions} />
                                <SimpleItem dataField="Расчетный_счет" editorType="dxTextArea" editorOptions={bpolRsEditorOptions} />
                                <GroupItem colCount={2}>
                                    <SimpleItem dataField="БИК" editorType="dxTextArea" editorOptions={bpolBicEditorOptions} />
                                    <SimpleItem dataField="Кор._счет" editorType="dxTextArea" editorOptions={bpolKsEditorOptions}>
                                        <Label text={"Кор. счёт"}/>
                                    </SimpleItem>
                                </GroupItem>
                            </GroupItem>
                        </GroupItem>
                    </Form>
                </div>
                <div className="col-md-6 mt20md">
                    <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faCircleInfo} />
                    <h3><strong>Информация о контрагенте</strong></h3>
                    <Form labelMode={'floating'} id="form-dogovor2" readOnly={true}>
                        <GroupItem caption="">
                            <SimpleItem dataField="Наименование_контрагента"  editorType="dxTextArea" editorOptions={nameEditorOptions} />
                            <GroupItem colCount={2}>
                                <SimpleItem dataField='ИНН' editorType="dxTextArea" editorOptions={innEditorOptions} />
                                <SimpleItem dataField="КПП" editorType="dxTextArea" editorOptions={kppEditorOptions} />
                            </GroupItem>
                            <GroupItem colCount={2} cssClass=''>
                                <SimpleItem dataField='ОКПО' editorType="dxTextArea" editorOptions={okpoEditorOptions} />
                                <SimpleItem dataField="ОГРН" editorType="dxTextArea" editorOptions={ogrnEditorOptions} />
                            </GroupItem>
                            <SimpleItem dataField="ОКВЭД" editorType="dxTextArea" editorOptions={okvedUrEditorOptions} cssClass='display-tatenergosbyt'/>
                            <SimpleItem dataField="ФИО руководителя" editorType="dxTextArea" editorOptions={fioDirEditorOptions} cssClass='display-tatenergosbyt'/>
                            <SimpleItem cssClass={'textarea-readonly'} dataField="Адрес_юридический" editorType="dxTextArea" readOnly={false} editorOptions={adrUrEditorOptions} />
                            <SimpleItem cssClass={'textarea-readonly'} dataField="Адрес_фактический" editorType="dxTextArea" editorOptions={adrDEditorOptions} />
                            <SimpleItem cssClass={'textarea-readonly'} dataField="Адрес_для_переписки" editorType="dxTextArea" editorOptions={adrDPEditorOptions} />

                            <GroupItem colCount={1} caption="Обслуживающий филиал" cssClass='display-tatenergosbyt'>
                                <SimpleItem dataField="Наименование" editorType="dxTextArea" editorOptions={filialNameEditorOptions} />
                                <SimpleItem dataField="Адрес" editorType="dxTextArea" editorOptions={filialAdrEditorOptions} />
                            </GroupItem>

                            {/*<ButtonItem>
                                <ButtonOptions useSubmitBehavior={false} type="default" icon="edit" text="Подать заявку на изменение адреса" onClick={onClick} />
                            </ButtonItem>*/}
                        </GroupItem>
                    </Form>
                    {/*<div className="row mt20">
                        <div className="col-12 col-sm-6 mb-2">
                            <Button
                                type={'default'}
                                className={'block big-button'}
                                text="Изменение юридического адреса"
                                onClick={() => openReqPopup(true, 2, `Прошу изменить адрес юридический для договора в связи с: впишите сюда причину смены адреса.`)}
                            />
                        </div>
                        <div className="col-12 col-sm-6 mb-2">
                            <Button
                                type={'default'}
                                className={'block big-button'}
                                text="Изменение адреса для переписки"
                                onClick={() => openReqPopup(true, 2, "Прошу изменить адрес для переписки для договора в связи с: впишите сюда причину смены адреса.")}
                            />
                        </div>
                    </div>*/}
                </div>
            </div>
            {isTatenergosbyt ? (
            <>
            <div className="mt20">
                {renderDocuments()}
            </div>
            {manager &&
            <div className="mt20">
                <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faCircleUser} />
                <h3><strong>Персональный менеджер по договору</strong></h3>
                <Form labelMode={'floating'} labelLocation={'top'} id="form-manager" readOnly={true} visible={!loadingManager}>
                    <GroupItem caption="" colCount={3}>
                        <SimpleItem dataField="ФИО" editorType="dxTextArea" editorOptions={{value: manager?.fio, autoResizeEnabled:true}}/>
                        <SimpleItem dataField='Email' editorType="dxTextArea" editorOptions={{value: manager?.eMail, autoResizeEnabled:true}}/>
                        <SimpleItem dataField="Телефон" editorType="dxTextArea" editorOptions={{value: manager?.tel, autoResizeEnabled:true}}/>
                    </GroupItem>
                </Form>
            </div>
            }
            </>
            ) : (
            <div className="row mt20">
                <div className="col-md-6">
                    <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faCircleUser} />
                    <h3><strong>Сведения об ответственных лицах заявителя</strong></h3>
                    <Form labelMode={'floating'} id="form-dogovor3" readOnly={true}>
                        {hasResponsibleNotification && (
                        <GroupItem caption="Контакты для направления уведомлений о введении ограничения режима потребления электрической энергии:">
                            <GroupItem colCount={2}>
                                <SimpleItem dataField="Мобильный_телефон" editorType="dxTextArea" editorOptions={textAreaOptions(responsibleNotification.tel)}/>
                                <SimpleItem dataField='Факс' editorType="dxTextArea"  editorOptions={textAreaOptions(responsibleNotification.fax)}/>
                            </GroupItem>
                            <SimpleItem dataField='Email' editorType="dxTextArea"  editorOptions={textAreaOptions(responsibleNotification.email)}/>
                        </GroupItem>
                        )}
                        {hasResponsibleExecution && (
                        <GroupItem caption="Лицо, ответственное за исполнение договора энергоснабжения:">
                            <SimpleItem cssClass="responsible-execution-item" render={renderExecutionResponsibilities}/>
                            <SimpleItem dataField="ФИО" editorType="dxTextArea" editorOptions={textAreaOptions(responsibleExecution.fio)}/>
                            <GroupItem colCount={2}>
                                <SimpleItem dataField="Телефон" editorType="dxTextArea"  editorOptions={textAreaOptions(responsibleExecution.tel)}/>
                                <SimpleItem dataField='Email' editorType="dxTextArea"  editorOptions={textAreaOptions(responsibleExecution.email)}/>
                            </GroupItem>
                        </GroupItem>
                        )}
                        {hasResponsibleMeters && (
                        <GroupItem caption="Лицо, ответственное за приборы и показания:">
                            <SimpleItem dataField="ФИО" editorType="dxTextArea" editorOptions={textAreaOptions(responsibleMeters.fio)}/>
                            <GroupItem colCount={2}>
                                <SimpleItem dataField="Телефон" editorType="dxTextArea"  editorOptions={textAreaOptions(responsibleMeters.tel)}/>
                                <SimpleItem dataField='Email' editorType="dxTextArea"  editorOptions={textAreaOptions(responsibleMeters.email)}/>
                            </GroupItem>
                        </GroupItem>
                        )}
                        {hasResponsiblePayments && (
                        <GroupItem caption="Лицо, ответственное за взаиморасчеты и получение счетов на оплату:">
                            <SimpleItem dataField="ФИО" editorType="dxTextArea" editorOptions={textAreaOptions(responsiblePayments.fio)}/>
                            <GroupItem colCount={2}>
                                <SimpleItem dataField="Телефон" editorType="dxTextArea"  editorOptions={textAreaOptions(responsiblePayments.tel)}/>
                                <SimpleItem dataField='Email' editorType="dxTextArea"  editorOptions={textAreaOptions(responsiblePayments.email)}/>
                            </GroupItem>
                        </GroupItem>
                        )}
                    </Form>
                </div>
                <div className="col-md-6 mt20md">
                    {renderDocuments()}
                </div>
            </div>
            )}
            </>
            )}
        </div>
        : <AccessDenied/>}</>
    )
}

export default Dogovor
